interface LoggerOptions {
  level: string;
  sentryLogging?: boolean;
  extra?: any;
}

const Logger = {
  trace: (message: string, options?: LoggerOptions): void => {
    if (process.env.NODE_ENV === 'development' || (options && options.level === 'Error')) {
      console.error(`[DateService] ${message}`, options && options.extra);
    }
  }
};

export default Logger;